export const INSIGHTS_LATEST_COUNT = 3;
export const INSIGHTS_SIDEBAR_VISIBLE_CATEGORIES = 5;

export const liftAboveStretchedLinkSx = {
  position: "relative",
  zIndex: 1,
} as const;

export const insightMetaChipsRowSx = {
  display: "flex",
  flexWrap: { xs: "wrap", sm: "nowrap" },
  alignItems: "center",
  gap: 0.5,
  "& > *": { flex: "0 0 auto" },
  ...liftAboveStretchedLinkSx,
} as const;

export const colorByInsightTagKey: Record<string, string> = {
  blue: "#3B82F6",
  violet: "#7C3AED",
  pink: "#EC4899",
  amber: "#F59E0B",
  emerald: "#10B981",
  slate: "#64748B",
};

export const bgColorByInsightTagKey: Record<string, string> = {
  blue: "#EFF6FF",
  violet: "#F5F3FF",
  pink: "#FDF2F8",
  amber: "#FFFBEB",
  emerald: "#ECFDF5",
  slate: "#F8FAFC",
};

export const DEFAULT_INSIGHT_CATEGORY_COLOR = "#000000";

export const getInsightTagColor = (
  colorKey: string | null | undefined
): string => colorByInsightTagKey[colorKey ?? ""] ?? colorByInsightTagKey.blue;

export const getInsightCategoryColor = (
  color: string | null | undefined
): string => color ?? DEFAULT_INSIGHT_CATEGORY_COLOR;
